import EvoTalksTemplateVariableModel from '@/models/crm/evotalks-template-variable.model';
import EvoTalksFilaAtendenteModel from '@/models/crm/evotalks-fila-atendente.model';

export interface IEvoTalksTemplateSend {
  queue: EvoTalksFilaAtendenteModel;
  templateId: number;
  values: string[];
}

export type EvoTalksTemplateValues = Record<number, string>;

export type EvoTalksTemplatePreviewPart =
  | { kind: 'text'; value: string }
  | { kind: 'variable'; position: number; value: string };

const markerPattern = /\{\{\s*(\d+)\s*\}\}/g;

export function initialTemplateValues(variables: EvoTalksTemplateVariableModel[] = []): EvoTalksTemplateValues {
  const values: EvoTalksTemplateValues = {};
  variables.forEach((variable) => {
    values[variable.position] = variable.defaultValue ?? '';
  });
  return values;
}

export function isTemplateComplete(
  variables: EvoTalksTemplateVariableModel[] = [],
  values: EvoTalksTemplateValues,
): boolean {
  return variables.every((variable) => (values[variable.position] ?? '').trim() !== '');
}

// Ordem dos marcadores = ordem do `data[]` posicional do envio.
export function orderedTemplateValues(
  variables: EvoTalksTemplateVariableModel[] = [],
  values: EvoTalksTemplateValues,
): string[] {
  return [...variables]
    .sort((a, b) => a.position - b.position)
    .map((variable) => (values[variable.position] ?? '').trim());
}

export function templatePreviewParts(text: string, values: EvoTalksTemplateValues): EvoTalksTemplatePreviewPart[] {
  const parts: EvoTalksTemplatePreviewPart[] = [];
  let last = 0;
  Array.from(text.matchAll(markerPattern)).forEach((match) => {
    const index = match.index ?? 0;
    if (index > last) {
      parts.push({ kind: 'text', value: text.slice(last, index) });
    }
    const position = Number(match[1]);
    parts.push({ kind: 'variable', position, value: (values[position] ?? '').trim() });
    last = index + match[0].length;
  });
  if (last < text.length) {
    parts.push({ kind: 'text', value: text.slice(last) });
  }
  return parts;
}
